// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Glory */
@media (min-width: 1200px) {
  .timelinectrl {
    width: 100%;
    height: 100vh;
  }
  .controls {
    width: 40px;
    height: 40px;
    position: absolute;
    left: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .controls:hover:after {
    transform: translateX(-10px) rotate(45deg);
  }
  .controls:hover:active:after {
    transform: translateX(-20px) rotate(45deg);
    transition: 300ms all;
  }
  .controls:after {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    transform: rotate(45deg);
    border-left: 4px solid #fff;
    border-bottom: 4px solid #fff;
    transition: 500ms all;
  }
  .controls.next {
    left: auto;
    right: 120px;
    transform: rotate(180deg);
  }
  .time-line {
    width: 100%;
    height: 100%;
    background-color: #152046;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    bottom: 0;
  }
  .time-line * {
    transition: 800ms all cubic-bezier(0.23, 1, 0.32, 1);
  }
  .time-line .dates-overflow {
    left: 0;
    width: 500vw;
    position: absolute;
    bottom: 50px;
    height: 40%;
  }
  .time-line .dates-wrap {
    display: inline-block;
    position: absolute;
    height: 100%;
    left: calc(45vw - 80px);
  }
  .time-line .dates-wrap:before, .time-line .dates-wrap:after {
    content: "";
    position: absolute;
    width: 160px;
    height: 50%;
    left: -1px;
    transform: translate(-50%, -50%);
    background: linear-gradient(to right, #152046 0%, rgba(125, 185, 232, 0) 100%);
    z-index: 2;
  }
  .time-line .dates-wrap:after {
    left: auto;
    right: -1px;
    background: linear-gradient(to left, #152046 0%, rgba(125, 185, 232, 0) 100%);
    transform: translate(50%, -50%);
  }
  .time-line .dates-wrap .date {
    width: 160px;
    position: relative;
    float: left;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 800ms all cubic-bezier(0.23, 1, 0.32, 1);
  }
  .time-line .dates-wrap .date .date-content {
    visibility: hidden;
    position: absolute;
    text-align: center;
    width: 340px;
    height: 340px;
    bottom: 100%;
    margin-bottom: 75px;
    border-radius: 3px;
    transform-origin: 50% 100%;
    transform: scale(0.7);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0);
  }
  .time-line .dates-wrap .date .date-content:after {
    content: "";
    position: absolute;
    left: 50%;
    width: 1px;
    top: 100%;
    margin-top: 8px;
    height: 60px;
    opacity: 0;
    background-color: #fff;
    transform: scaleY(0);
    transform-origin: 100% 100%;
    transition: 800ms all cubic-bezier(0.23, 1, 0.32, 1);
  }
  .time-line .dates-wrap .date .date-content .date-image img {
    width: 200px;
    object-fit: contain;
  }
  .time-line .dates-wrap .date .date-content > div {
    opacity: 0;
    transform: translateY(40px);
  }
  .time-line .dates-wrap .date .date-content .date-text {
    width: 500px;
    height: 60px;
    position: absolute;
    bottom: -300px;
    color: white;
    font-size: 1.5rem;
  }
  .time-line .dates-wrap .date .date-year {
    opacity: 0.4;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .time-line .dates-wrap .date .date-year:hover {
    opacity: 1 !important;
  }
  .time-line .dates-wrap .date .date-year:hover:after {
    transform: scale(1) !important;
  }
  .time-line .dates-wrap .date .date-year p {
    position: absolute;
    top: 10%;
    line-height: 0;
    color: #fff;
    font-size: 35px;
    font-weight: 900;
    transform: scale(0.4);
    z-index: 2;
  }
  .time-line .dates-wrap .date .date-year:after {
    content: "";
    position: absolute;
    width: 14px;
    height: 14px;
    background-color: #fff;
    bottom: 100%;
    margin-bottom: -7px;
    border-radius: 50%;
    transform: scale(0.4);
    transition: 500ms all;
  }
  .time-line .dates-wrap .date .date-year:before {
    content: "";
    position: absolute;
    top: 0;
    width: 200%;
    height: 1px;
    background-color: #fff;
  }
  .time-line .dates-wrap .date.sibling .date-year {
    opacity: 0.6;
  }
  .time-line .dates-wrap .date.sibling .date-year:after {
    transform: scale(0.8);
  }
  .time-line .dates-wrap .date.sibling .date-year p {
    transform: scale(0.6);
  }
  .time-line .dates-wrap .date.active + .date .date-year {
    opacity: 0.6;
  }
  .time-line .dates-wrap .date.active + .date .date-year:after {
    transform: scale(0.8);
  }
  .time-line .dates-wrap .date.active + .date .date-year p {
    transform: scale(0.6);
  }
  .time-line .dates-wrap .date.active .date-year {
    opacity: 1;
  }
  .time-line .dates-wrap .date.active .date-year:before {
    width: calc(200% - 11px);
  }
  .time-line .dates-wrap .date.active .date-year:after {
    transform: scale(1);
  }
  .time-line .dates-wrap .date.active .date-year p {
    transform: scale(1.2);
  }
  .time-line .dates-wrap .date.active .date-content {
    transform: scale(1);
    visibility: visible;
  }
  .time-line .dates-wrap .date.active .date-content:after {
    transition-delay: 200ms;
    opacity: 1;
    transform: scaleY(1);
  }
  .time-line .dates-wrap .date.active .date-content div {
    transition-delay: 200ms;
    opacity: 1;
    transform: translateY(0px) scale(1);
  }
}
@media (max-width: 1200px) {
  .mglory {
    width: 80%;
    margin: auto;
    text-align: center;
  }
  .myear p {
    font-size: 3rem;
  }
  .mimg img {
    width: 50%;
    margin-bottom: 2rem;
  }
  .mtext {
    width: 80%;
    margin: auto;
    margin-bottom: 5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/about/styles/glory.scss"],"names":[],"mappings":"AAAA,UAAA;AAEA;EACI;IACI,WAAA;IACA,aAAA;EAAN;EAEF;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,WAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,eAAA;EAAF;EAGE;IACI,0CAAA;EADN;EAKM;IACA,0CAAA;IACA,qBAAA;EAHN;EAQE;IACA,WAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,wBAAA;IACA,2BAAA;IACA,6BAAA;IACA,qBAAA;EANF;EASE;IACA,UAAA;IACA,YAAA;IACA,yBAAA;EAPF;EAWE;IACA,WAAA;IACA,YAAA;IACA,yBAlDC;IAmDD,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,kBAAA;IACA,SAAA;EATF;EAaE;IACA,oDAAA;EAXF;EAcE;IACA,OAAA;IACA,YAAA;IACA,kBAAA;IACA,YAAA;IACA,WAAA;EAZF;EAeE;IACA,qBAAA;IACA,kBAAA;IACA,YAAA;IACA,uBAAA;EAbF;EAeE;IACI,WAAA;IACA,kBAAA;IACA,YAAA;IACA,WAAA;IACA,UAAA;IACA,gCAAA;IACA,8EAAA;IACA,UAAA;EAbN;EAgBE;IACI,UAAA;IACA,WAAA;IACA,6EAAA;IACA,+BAAA;EAdN;EAiBE;IACI,YAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,oDAAA;EAfN;EAiBM;IACA,kBAAA;IACA,kBAAA;IACA,kBAAA;IACA,YAAA;IACA,aAAA;IACA,YAAA;IACA,mBAAA;IACA,kBAAA;IACA,0BAAA;IACA,qBAAA;IACA,wCAAA;EAfN;EAiBM;IACI,WAAA;IACA,kBAAA;IACA,SAAA;IACA,UAAA;IACA,SAAA;IACA,eAAA;IACA,YAAA;IACA,UAAA;IACA,sBAAA;IACA,oBAAA;IACA,2BAAA;IACA,oDAAA;EAfV;EAkBM;IACI,YAAA;IACA,mBAAA;EAhBV;EAmBM;IACI,UAAA;IACA,2BAAA;EAjBV;EAoBM;IACI,YAAA;IACA,YAAA;IACA,kBAAA;IACA,cAAA;IACA,YAAA;IACA,iBAAA;EAlBV;EAsBM;IACA,YAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,eAAA;EApBN;EAuBM;IACI,qBAAA;EArBV;EAsBU;IACA,8BAAA;EApBV;EAwBM;IACI,kBAAA;IACA,QAAA;IACA,cAAA;IACA,WAAA;IACA,eAAA;IACA,gBAAA;IACA,qBAAA;IACA,UAAA;EAtBV;EAyBM;IACI,WAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,sBAAA;IACA,YAAA;IACA,mBAAA;IACA,kBAAA;IACA,qBAAA;IACA,qBAAA;EAvBV;EA0BM;IACI,WAAA;IACA,kBAAA;IACA,MAAA;IACA,WAAA;IACA,WAAA;IACA,sBAAA;EAxBV;EA6BM;IACI,YAAA;EA3BV;EA4BU;IACA,qBAAA;EA1BV;EA4BU;IACA,qBAAA;EA1BV;EAiCU;IACA,YAAA;EA/BV;EAiCU;IACI,qBAAA;EA/Bd;EAiCU;IACI,qBAAA;EA/Bd;EAoCM;IACI,UAAA;EAlCV;EAmCU;IACA,wBAAA;EAjCV;EAmCU;IACI,mBAAA;EAjCd;EAmCU;IACA,qBAAA;EAjCV;EAqCM;IACI,mBAAA;IACA,mBAAA;EAnCV;EAqCU;IACA,uBAAA;IACA,UAAA;IACA,oBAAA;EAnCV;EAqCU;IACA,uBAAA;IACA,UAAA;IACA,mCAAA;EAnCV;AACF;AA6CA;EACI;IACI,UAAA;IACA,YAAA;IACA,kBAAA;EA3CN;EA6CE;IACI,eAAA;EA3CN;EA6CE;IACI,UAAA;IACA,mBAAA;EA3CN;EA6CE;IACI,UAAA;IACA,YAAA;IACA,mBAAA;EA3CN;AACF","sourcesContent":["/* Glory */\n$bg: #152046;\n@media (min-width:1200px) {\n    .timelinectrl {\n        width: 100%;\n        height: 100vh;\n}\n.controls {\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    left: 120px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    \n    &:hover {\n    &:after {\n        transform: translateX(-10px) rotate(45deg);\n    }\n    \n    &:active {\n        &:after {\n        transform: translateX(-20px) rotate(45deg);\n        transition: 300ms all;\n        }\n    }\n    }\n    \n    &:after {\n    content: \"\";\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    transform: rotate(45deg);\n    border-left: 4px solid #fff;\n    border-bottom: 4px solid #fff;\n    transition: 500ms all;\n    }\n    \n    &.next {\n    left: auto;\n    right: 120px;\n    transform: rotate(180deg);\n    }\n    }\n    \n    .time-line {\n    width: 100%;\n    height: 100%;\n    background-color:$bg;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    bottom: 0;\n    // overflow-x: hidden;\n    \n    \n    * {\n    transition: 800ms all cubic-bezier(0.23, 1, 0.32, 1);\n    }\n    \n    .dates-overflow {\n    left: 0;\n    width: 500vw;\n    position: absolute;\n    bottom: 50px;\n    height: 40%;\n    }\n    \n    .dates-wrap {\n    display: inline-block;  \n    position: absolute;\n    height: 100%;\n    left: calc(45vw - 80px);\n    \n    &:before, &:after {\n        content: '';\n        position: absolute;\n        width: 160px;\n        height: 50%;\n        left: -1px;\n        transform: translate(-50%, -50%);\n        background: linear-gradient(to right, #152046 0%,rgba(125,185,232,0) 100%);\n        z-index: 2;\n    }\n    \n    &:after {\n        left: auto;\n        right: -1px;\n        background: linear-gradient(to left, #152046 0%,rgba(125,185,232,0) 100%);\n        transform: translate(50%, -50%);\n    }\n    \n    .date {\n        width: 160px;\n        position: relative;\n        float: left;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        transition: 800ms all cubic-bezier(0.23, 1, 0.32, 1);\n    \n        .date-content {\n        visibility: hidden;\n        position: absolute;\n        text-align: center;\n        width: 340px;\n        height: 340px;\n        bottom: 100%;\n        margin-bottom: 75px;\n        border-radius: 3px;\n        transform-origin: 50% 100%;\n        transform: scale(0.7);\n        box-shadow: 0 10px 30px rgba(0,0,0,0);\n    \n        &:after {\n            content: \"\";\n            position: absolute;\n            left: 50%;\n            width: 1px;\n            top: 100%;\n            margin-top: 8px;\n            height: 60px;\n            opacity: 0;\n            background-color: #fff;\n            transform: scaleY(0);\n            transform-origin: 100% 100%;\n            transition: 800ms all cubic-bezier(0.23, 1, 0.32, 1);\n        }\n    \n        .date-image img{\n            width: 200px;\n            object-fit: contain;\n        }\n    \n        > div {\n            opacity: 0;\n            transform: translateY(40px);\n        }\n    \n        .date-text {\n            width:500px;\n            height: 60px;\n            position: absolute;\n            bottom: -300px;\n            color: #ffff;\n            font-size: 1.5rem;\n        }\n        }\n    \n        .date-year {\n        opacity: 0.4;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        \n        \n        &:hover {\n            opacity: 1 !important;\n            &:after {\n            transform: scale(1) !important;\n            }\n        }\n    \n        p {\n            position: absolute;\n            top: 10%;\n            line-height: 0;\n            color: #fff;\n            font-size: 35px;\n            font-weight: 900;\n            transform: scale(0.4);\n            z-index: 2;\n        }\n    \n        &:after {\n            content: \"\";\n            position: absolute;\n            width: 14px;\n            height: 14px;\n            background-color: #fff;\n            bottom: 100%;\n            margin-bottom: -7px;\n            border-radius: 50%;\n            transform: scale(0.4);\n            transition: 500ms all;\n        }\n    \n        &:before {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            width: 200%;\n            height: 1px;\n            background-color: #fff;\n        }\n        }\n    \n        &.sibling {\n        .date-year {\n            opacity: 0.6;\n            &:after {\n            transform: scale(0.8);\n            }\n            p {\n            transform: scale(0.6);\n            }\n        }\n        }\n    \n        &.active {\n        & + .date {\n            .date-year {\n            opacity: 0.6;\n            \n            &:after {\n                transform: scale(0.8);\n            }          \n            p {\n                transform: scale(0.6);\n            }\n            }\n        }\n        \n        .date-year {\n            opacity: 1;\n            &:before {\n            width: calc(200% - 11px);\n            }\n            &:after {\n                transform: scale(1);\n            } \n            p {\n            transform: scale(1.2);\n            }\n        }\n    \n        .date-content {\n            transform: scale(1);\n            visibility: visible;         \n            \n            &:after {\n            transition-delay: 200ms;\n            opacity: 1;\n            transform: scaleY(1);\n            }\n            div {\n            transition-delay: 200ms;\n            opacity: 1;\n            transform: translateY(0px) scale(1);\n            }\n        }\n        }\n    }\n    \n    }\n    }\n}\n\n\n@media (max-width:1200px) {\n    .mglory {\n        width: 80%;\n        margin: auto;\n        text-align: center;\n    }\n    .myear p{\n        font-size: 3rem;\n    }\n    .mimg img{\n        width: 50%;\n        margin-bottom: 2rem;\n    }\n    .mtext {\n        width: 80%;\n        margin: auto;\n        margin-bottom: 5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
